module.exports = __webpack_public_path__ + "media/jason_de_ridder-autoritair.860592a1.mp4";